export default "__VITE_ASSET__BiTLdCyJ__"